document.addEventListener('DOMContentLoaded', function() {
  const viewMoreBtn = document.querySelector('.view-more-btn');
  const viewAllActivesBtn = document.querySelector('.view-all-actives-btn');
  const collectionItems = document.querySelectorAll('.featured-collections-slider--item');

  if (window.innerWidth >= 720) {
    if (viewMoreBtn) viewMoreBtn.style.display = 'none';
    if (viewAllActivesBtn) viewAllActivesBtn.style.display = 'none';
  }

  if (window.innerWidth < 720 && collectionItems.length > 4) {
    if (viewAllActivesBtn) viewAllActivesBtn.style.display = 'none';

    if (viewMoreBtn) {
      viewMoreBtn.addEventListener('click', function() {
        collectionItems.forEach(function(item) {
          if (!item.classList.contains('promo-block-mosaic')) {
            item.style.opacity = '0';
            item.style.display = '';
            // Trigger fade in
            requestAnimationFrame(function() {
              item.style.transition = 'opacity 1s';
              item.style.opacity = '1';
            });
          }
        });
        viewMoreBtn.style.display = 'none';
        if (viewAllActivesBtn) viewAllActivesBtn.style.display = '';
      });
    }
  }

  if (window.innerWidth < 720 && collectionItems.length <= 4) {
    if (viewMoreBtn) viewMoreBtn.style.display = 'none';
  }
});
